export function init($name = '') {
    let elem = $($name);

    if (!elem.length) {
        return;
    }

    elem.click(function() {
        if ($(this).hasClass('is-active')) {
            return;
        }

        const id = $(this).data('elem');

        elem.removeClass('is-active');
        $(this).parents($name + '-parent').find($name + '-content').removeClass('is-active');

        $(this).addClass('is-active');
        $(this).parents($name + '-parent').find($name + '-content[data-elem="' + id + '"]').addClass('is-active');
    });
}